import { AuthConfig } from 'angular-oauth2-oidc';
import { environment } from '../../environments/environment';

export const authConfig: AuthConfig = {
  tokenEndpoint: `${environment.apiUrl}/api/token`,
  responseType: 'token',
  clientId: 'test_client',
  dummyClientSecret: 'secret',
  requireHttps: false,
  scope: '',
  userinfoEndpoint: `${environment.apiUrl}/api/profile`,
  oidc: false,
  timeoutFactor: 0.5,
  // showDebugInformation: true,
};
